import React, { useEffect, useState } from "react";
import { AnimatePresence, m } from "framer-motion";
import Header from "../../../components/Header";
import Cookies from "universal-cookie";
import { container, item } from "../RecruitmentDashBoard/constants";
import BreadCrumb from "../../../components/BreadCrumb";
import { WhatsAppOutlined } from '@ant-design/icons';
import {
  Button,
  Divider,
  Input,
  message,
  Modal,
  Pagination,
  Table,
  Form,
  Select,
  DatePicker,
  Space,
  Popconfirm
} from "antd";
import TextArea from "antd/es/input/TextArea";
import {
  EditOutlined,
  DeleteOutlined,
  MailOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import RecruitmentTrackerForm from "./recruitmenttrackercreate";
import axios from "axios";
import dayjs from "dayjs";
import { useQuery } from "react-query";
import { string } from "../../../utilities";
import { FaFilter } from "react-icons/fa";
import { AiOutlineSearch } from "react-icons/ai";
import RecruitmentTrackerFilter from "./recruitmentTrackerFilter";
import { checkFilterActive } from "../../../utilities";
import "./recruitmenttrackers.css";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";

const { Dragger } = Upload;

const RecruitmentTrackers = ({ language, changeLanguage }) => {
  const [jsonData, setJsonData] = useState([]);
  const [uploadModal, toggleUploadModal] = useState(false);
  const { t } = useTranslation();
  const cookies = new Cookies();
  const token = cookies.get("token");
  var localizedFormat = require("dayjs/plugin/localizedFormat");
  dayjs.extend(localizedFormat);
  const [name, setName] = useState("");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [isExcelLoading, setExcelLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [isModalOpen, toggleModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deletionData, setDeletionData] = useState(null);
  const [deleteModal, toggleDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isCommentModal, toggleCommentModal] = useState(false);
  const [isLoadingMail, setLoadingMail] = useState(false);
  const [filter, setFilter] = useState({
    search: "",
    candidate: "",
    client: "",
    job: "",
    interview: "",
  });
  const [isFilterModal, toggleFilterModal] = useState(false);
  const [isEmailModalOpen, setEmailModel] = useState(false);
  const [emailContent, setEmailContent] = useState({
    id: 0,
    email: "",
    subject: "",
    message: "",
  });

  const { data: createdBy, isFetching: createdByFetching } = useQuery(
    ["createdBy"],
    () =>
      axios.get("/api/recruitment", {
        headers: {
          Authorization: token,
        },
      }),
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        const newData = data.data.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        return newData;
      },
    }
  );

  const { data: clientsList, isFetching: clientFetching } = useQuery(
    ["clients"],
    () =>
      axios.get("/api/client", {
        headers: {
          Authorization: token,
        },
      }),
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        const newData = data.data.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        return newData;
      },
    }
  );

  const { data: jobsList, isFetching: jobFetching } = useQuery(
    ["jobs"],
    () =>
      axios.get("/api/recruitment/job", {
        headers: {
          Authorization: token,
        },
      }),
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        const newData = data.data.data.map((item) => ({
          label: item.designation,
          value: item.id,
        }));
        return newData;
      },
    }
  );

  const status = [
    {
      id: 1,
      label: "shotlisted",
      value: "shortlisted",
    },
    {
      id: 2,
      label: "not shortlisted",
      value: "not shortlisted",
    },
  ];

  const cvuploaded = [
    {
      id: 1,
      label: "Yes",
      value: "Yes",
    },
    {
      id: 2,
      label: "No",
      value: "No",
    },
  ];

  const nation = [
    {
      id: 1,
      label: "Afghanistan",
      value: "Afghanistan",
    },
    {
      id: 2,
      label: "Aland Islands",
      value: "Aland Islands",
    },
    {
      id: 3,
      label: "Albania",
      value: "Albania",
    },
    {
      id: 4,
      label: "Algeria",
      value: "Algeria",
    },
    {
      id: 5,
      label: "American Samoa",
      value: "American Samoa",
    },
    {
      id: 6,
      label: "Andorra",
      value: "Andorra",
    },
    {
      id: 7,
      label: "Angola",
      value: "Angola",
    },
    {
      id: 8,
      label: "Anguilla",
      value: "Anguilla",
    },
    {
      id: 9,
      label: "Antarctica",
      value: "Antarctica",
    },
    {
      id: 10,
      label: "Antigua and Barbuda",
      value: "Antigua and Barbuda",
    },
    {
      id: 11,
      label: "Argentina",
      value: "Argentina",
    },
    {
      id: 12,
      label: "Armenia",
      value: "Armenia",
    },
    {
      id: 13,
      label: "Aruba",
      value: "Aruba",
    },
    {
      id: 14,
      label: "Australia",
      value: "Australia",
    },
    {
      id: 15,
      label: "Austria",
      value: "Austria",
    },
    {
      id: 16,
      label: "Azerbaijan",
      value: "Azerbaijan",
    },
    {
      id: 17,
      label: "Bahamas",
      value: "Bahamas",
    },
    {
      id: 18,
      label: "Bahrain",
      value: "Bahrain",
    },
    {
      id: 19,
      label: "Bangladesh",
      value: "Bangladesh",
    },
    {
      id: 20,
      label: "Barbados",
      value: "Barbados",
    },
    {
      id: 21,
      label: "Belarus",
      value: "Belarus",
    },
    {
      id: 22,
      label: "Belgium",
      value: "Belgium",
    },
    {
      id: 23,
      label: "Belize",
      value: "Belize",
    },
    {
      id: 24,
      label: "Benin",
      value: "Benin",
    },
    {
      id: 25,
      label: "Bermuda",
      value: "Bermuda",
    },
    {
      id: 26,
      label: "Bhutan",
      value: "Bhutan",
    },
    {
      id: 27,
      label: "Bolivia (Plurinational State of)",
      value: "Bolivia (Plurinational State of)",
    },
    {
      id: 28,
      label: "Bonaire",
      value: "Bonaire",
    },
    {
      id: 29,
      label: "Bosnia and Herzegovina",
      value: "Bosnia and Herzegovina",
    },
    {
      id: 30,
      label: "Botswana",
      value: "Botswana",
    },
    {
      id: 31,
      label: "Bouvet Island",
      value: "Bouvet Island",
    },
    {
      id: 32,
      label: "Brazil",
      value: "Brazil",
    },
    {
      id: 33,
      label: "British Indian Ocean Territory",
      value: "British Indian Ocean Territory",
    },
    {
      id: 34,
      label: "Brunei Darussalam",
      value: "Brunei Darussalam",
    },
    {
      id: 35,
      label: "Bulgaria",
      value: "Bulgaria",
    },
    {
      id: 36,
      label: "Burkina Faso",
      value: "Burkina Faso",
    },
    {
      id: 37,
      label: "Burundi",
      value: "Burundi",
    },
    {
      id: 38,
      label: "Cabo Verde",
      value: "Cabo Verde",
    },
    {
      id: 39,
      label: "Cambodia",
      value: "Cambodia",
    },
    {
      id: 40,
      label: "Cameroon",
      value: "Cameroon",
    },
    {
      id: 41,
      label: "Canada",
      value: "Canada",
    },
    {
      id: 42,
      label: "Cayman Islands",
      value: "Cayman Islands",
    },
    {
      id: 43,
      label: "Central African Republic",
      value: "Central African Republic",
    },
    {
      id: 44,
      label: "Chad",
      value: "Chad",
    },
    {
      id: 45,
      label: "Chile",
      value: "Chile",
    },
    {
      id: 46,
      label: "China",
      value: "China",
    },
    {
      id: 47,
      label: "Christmas Island",
      value: "Christmas Island",
    },
    {
      id: 48,
      label: "Cocos (Keeling) Islands",
      value: "Cocos (Keeling) Islands",
    },
    {
      id: 49,
      label: "Colombia",
      value: "Colombia",
    },
    {
      id: 50,
      label: "Comoros",
      value: "Comoros",
    },
    {
      id: 51,
      label: "Congo (Republic of the)",
      value: "Congo (Republic of the)",
    },
    {
      id: 52,
      label: "Congo (Democratic Republic of the)",
      value: "Congo (Democratic Republic of the)",
    },
    {
      id: 53,
      label: "Cook Islands",
      value: "Cook Islands",
    },
    {
      id: 54,
      label: "Costa Rica",
      value: "Costa Rica",
    },
    {
      id: 55,
      label: "Cote dIvoire",
      value: "Cote dIvoire",
    },
    {
      id: 56,
      label: "Croatia",
      value: "Croatia",
    },
    {
      id: 57,
      label: "Cuba",
      value: "Cuba",
    },
    {
      id: 58,
      label: "Curacao",
      value: "Curacao",
    },
    {
      id: 59,
      label: "Cyprus",
      value: "Cyprus",
    },
    {
      id: 60,
      label: "Czech Republic",
      value: "Czech Republic",
    },
    {
      id: 61,
      label: "Denmark",
      value: "Denmark",
    },
    {
      id: 62,
      label: "Djibouti",
      value: "Djibouti",
    },
    {
      id: 63,
      label: "Dominica",
      value: "Dominica",
    },
    {
      id: 64,
      label: "Dominican Republic",
      value: "Dominican Republic",
    },
    {
      id: 65,
      label: "Ecuador",
      value: "Ecuador",
    },
    {
      id: 66,
      label: "Egypt",
      value: "Egypt",
    },
    {
      id: 67,
      label: "El Salvador",
      value: "El Salvador",
    },
    {
      id: 68,
      label: "Equatorial Guinea",
      value: "Equatorial Guinea",
    },
    {
      id: 69,
      label: "Eritrea",
      value: "Eritrea",
    },
    {
      id: 70,
      label: "Estonia",
      value: "Estonia",
    },
    {
      id: 71,
      label: "Ethiopia",
      value: "Ethiopia",
    },
    {
      id: 72,
      label: "Falkland Islands (Malvinas)",
      value: "Falkland Islands (Malvinas)",
    },
    {
      id: 73,
      label: "Faroe Islands",
      value: "Faroe Islands",
    },
    {
      id: 74,
      label: "Fiji",
      value: "Fiji",
    },
    {
      id: 75,
      label: "Finland",
      value: "Finland",
    },
    {
      id: 76,
      label: "France",
      value: "France",
    },
    {
      id: 77,
      label: "French Guiana",
      value: "French Guiana",
    },
    {
      id: 78,
      label: "French Polynesia",
      value: "French Polynesia",
    },
    {
      id: 79,
      label: "French Southern Territories",
      value: "French Southern Territories",
    },
    {
      id: 80,
      label: "Gabon",
      value: "Gabon",
    },
    {
      id: 81,
      label: "Gambia",
      value: "Gambia",
    },
    {
      id: 82,
      label: "Georgia",
      value: "Georgia",
    },
    {
      id: 83,
      label: "Germany",
      value: "Germany",
    },
    {
      id: 84,
      label: "Ghana",
      value: "Ghana",
    },
    {
      id: 85,
      label: "Gibraltar",
      value: "Gibraltar",
    },
    {
      id: 86,
      label: "Greece",
      value: "Greece",
    },
    {
      id: 87,
      label: "Greenland",
      value: "Greenland",
    },
    {
      id: 88,
      label: "Grenada",
      value: "Grenada",
    },
    {
      id: 89,
      label: "Guadeloupe",
      value: "Guadeloupe",
    },
    {
      id: 90,
      label: "Guam",
      value: "Guam",
    },
    {
      id: 91,
      label: "Guatemala",
      value: "Guatemala",
    },
    {
      id: 92,
      label: "Guernsey",
      value: "Guernsey",
    },
    {
      id: 93,
      label: "Guinea",
      value: "Guinea",
    },
    {
      id: 94,
      label: "Guinea-Bissau",
      value: "Guinea-Bissau",
    },
    {
      id: 95,
      label: "Guyana",
      value: "Guyana",
    },
    {
      id: 96,
      label: "Haiti",
      value: "Haiti",
    },
    {
      id: 97,
      label: "Heard Island and McDonald Islands",
      value: "Heard Island and McDonald Islands",
    },
    {
      id: 98,
      label: "Vatican City State",
      value: "Vatican City State",
    },
    {
      id: 99,
      label: "Honduras",
      value: "Honduras",
    },
    {
      id: 100,
      label: "Hong Kong",
      value: "Hong Kong",
    },
    {
      id: 101,
      label: "Hungary",
      value: "Hungary",
    },
    {
      id: 102,
      label: "Iceland",
      value: "Iceland",
    },
    {
      id: 103,
      label: "India",
      value: "India",
    },
    {
      id: 104,
      label: "Indonesia",
      value: "Indonesia",
    },
    {
      id: 105,
      label: "Iran",
      value: "Iran",
    },
    {
      id: 106,
      label: "Iraq",
      value: "Iraq",
    },
    {
      id: 107,
      label: "Ireland",
      value: "Ireland",
    },
    {
      id: 108,
      label: "Isle of Man",
      value: "Isle of Man",
    },
    {
      id: 109,
      label: "Israel",
      value: "Israel",
    },
    {
      id: 110,
      label: "Italy",
      value: "Italy",
    },
    {
      id: 111,
      label: "Jamaica",
      value: "Jamaica",
    },
    {
      id: 112,
      label: "Japan",
      value: "Japan",
    },
    {
      id: 113,
      label: "Jersey",
      value: "Jersey",
    },
    {
      id: 114,
      label: "Jordan",
      value: "Jordan",
    },
    {
      id: 115,
      label: "Kazakhstan",
      value: "Kazakhstan",
    },
    {
      id: 116,
      label: "Kenya",
      value: "Kenya",
    },
    {
      id: 117,
      label: "Kiribati",
      value: "Kiribati",
    },
    {
      id: 118,
      label: "Korea (Democratic Peoples Republic of)",
      value: "Korea (Democratic Peoples Republic of)",
    },
    {
      id: 119,
      label: "Korea (Republic of)",
      value: "Korea (Republic of)",
    },
    {
      id: 120,
      label: "Kuwait",
      value: "Kuwait",
    },
    {
      id: 121,
      label: "Kyrgyzstan",
      value: "Kyrgyzstan",
    },
    {
      id: 122,
      label: "Lao Peoples Democratic Republic",
      value: "Lao Peoples Democratic Republic",
    },
    {
      id: 123,
      label: "Latvia",
      value: "Latvia",
    },
    {
      id: 124,
      label: "Lebanon",
      value: "Lebanon",
    },
    {
      id: 125,
      label: "Lesotho",
      value: "Lesotho",
    },
    {
      id: 126,
      label: "Liberia",
      value: "Liberia",
    },
    {
      id: 127,
      label: "Libya",
      value: "Libya",
    },
    {
      id: 128,
      label: "Liechtenstein",
      value: "Liechtenstein",
    },
    {
      id: 129,
      label: "Lithuania",
      value: "Lithuania",
    },
    {
      id: 130,
      label: "Luxembourg",
      value: "Luxembourg",
    },
    {
      id: 131,
      label: "Macao",
      value: "Macao",
    },
    {
      id: 132,
      label: "Macedonia (the former Yugoslav Republic of)",
      value: "Macedonia (the former Yugoslav Republic of)",
    },
    {
      id: 133,
      label: "Madagascar",
      value: "Madagascar",
    },
    {
      id: 134,
      label: "Malawi",
      value: "Malawi",
    },
    {
      id: 135,
      label: "Malaysia",
      value: "Malaysia",
    },
    {
      id: 136,
      label: "Maldives",
      value: "Maldives",
    },
    {
      id: 137,
      label: "Mali",
      value: "Mali",
    },
    {
      id: 138,
      label: "Malta",
      value: "Malta",
    },
    {
      id: 139,
      label: "Marshall Islands",
      value: "Marshall Islands",
    },
    {
      id: 140,
      label: "Martinique",
      value: "Martinique",
    },
    {
      id: 141,
      label: "Mauritania",
      value: "Mauritania",
    },
    {
      id: 142,
      label: "Mauritius",
      value: "Mauritius",
    },
    {
      id: 143,
      label: "Mayotte",
      value: "Mayotte",
    },
    {
      id: 144,
      label: "Mexico",
      value: "Mexico",
    },
    {
      id: 145,
      label: "Micronesia (Federated States of)",
      value: "Micronesia (Federated States of)",
    },
    {
      id: 146,
      label: "Moldova (Republic of)",
      value: "Moldova (Republic of)",
    },
    {
      id: 147,
      label: "Monaco",
      value: "Monaco",
    },
    {
      id: 148,
      label: "Mongolia",
      value: "Mongolia",
    },
    {
      id: 149,
      label: "Montenegro",
      value: "Montenegro",
    },
    {
      id: 150,
      label: "Montserrat",
      value: "Montserrat",
    },
    {
      id: 151,
      label: "Morocco",
      value: "Morocco",
    },
    {
      id: 152,
      label: "Mozambique",
      value: "Mozambique",
    },
    {
      id: 153,
      label: "Myanmar",
      value: "Myanmar",
    },
    {
      id: 154,
      label: "Namibia",
      value: "Namibia",
    },
    {
      id: 155,
      label: "Nauru",
      value: "Nauru",
    },
    {
      id: 156,
      label: "Nepal",
      value: "Nepal",
    },
    {
      id: 157,
      label: "Netherlands",
      value: "Netherlands",
    },
    {
      id: 158,
      label: "New Caledonia",
      value: "New Caledonia",
    },
    {
      id: 159,
      label: "New Zealand",
      value: "New Zealand",
    },
    {
      id: 160,
      label: "Nicaragua",
      value: "Nicaragua",
    },
    {
      id: 161,
      label: "Niger",
      value: "Niger",
    },
    {
      id: 162,
      label: "Nigeria",
      value: "Nigeria",
    },
    {
      id: 163,
      label: "Niue",
      value: "Niue",
    },
    {
      id: 164,
      label: "Norfolk Island",
      value: "Norfolk Island",
    },
    {
      id: 165,
      label: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
    },
    {
      id: 166,
      label: "Norway",
      value: "Norway",
    },
    {
      id: 167,
      label: "Oman",
      value: "Oman",
    },
    {
      id: 168,
      label: "Pakistan",
      value: "Pakistan",
    },
    {
      id: 169,
      label: "Palau",
      value: "Palau",
    },
    {
      id: 170,
      label: "Palestine",
      value: "Palestine",
    },
    {
      id: 171,
      label: "Panama",
      value: "Panama",
    },
    {
      id: 172,
      label: "Papua New Guinea",
      value: "Papua New Guinea",
    },
    {
      id: 173,
      label: "Paraguay",
      value: "Paraguay",
    },
    {
      id: 174,
      label: "Peru",
      value: "Peru",
    },
    {
      id: 175,
      label: "Philippines",
      value: "Philippines",
    },
    {
      id: 176,
      label: "Pitcairn",
      value: "Pitcairn",
    },
    {
      id: 177,
      label: "Poland",
      value: "Poland",
    },
    {
      id: 178,
      label: "Portugal",
      value: "Portugal",
    },
    {
      id: 179,
      label: "Puerto Rico",
      value: "Puerto Rico",
    },
    {
      id: 180,
      label: "Qatar",
      value: "Qatar",
    },
    {
      id: 181,
      label: "Reunion",
      value: "Reunion",
    },
    {
      id: 182,
      label: "Romania",
      value: "Romania",
    },
    {
      id: 183,
      label: "Russian Federation",
      value: "Russian Federation",
    },
    {
      id: 184,
      label: "Rwanda",
      value: "Rwanda",
    },
    {
      id: 185,
      label: "Saint Barthelemy",
      value: "Saint Barthelemy",
    },
    {
      id: 186,
      label: "Saint Helena",
      value: "Saint Helena",
    },
    {
      id: 187,
      label: "Saint Kitts and Nevis",
      value: "Saint Kitts and Nevis",
    },
    {
      id: 188,
      label: "Saint Lucia",
      value: "Saint Lucia",
    },
    {
      id: 189,
      label: "Saint Martin (French part)",
      value: "Saint Martin (French part)",
    },
    {
      id: 190,
      label: "Saint Pierre and Miquelon",
      value: "Saint Pierre and Miquelon",
    },
    {
      id: 191,
      label: "Saint Vincent and the Grenadines",
      value: "Saint Vincent and the Grenadines",
    },
    {
      id: 192,
      label: "Samoa",
      value: "Samoa",
    },
    {
      id: 193,
      label: "San Marino",
      value: "San Marino",
    },
    {
      id: 194,
      label: "Sao Tome and Principe",
      value: "Sao Tome and Principe",
    },
    {
      id: 195,
      label: "Saudi Arabia",
      value: "Saudi Arabia",
    },
    {
      id: 196,
      label: "Senegal",
      value: "Senegal",
    },
    {
      id: 197,
      label: "Serbia",
      value: "Serbia",
    },
    {
      id: 198,
      label: "Seychelles",
      value: "Seychelles",
    },
    {
      id: 199,
      label: "Sierra Leone",
      value: "Sierra Leone",
    },
    {
      id: 200,
      label: "Singapore",
      value: "Singapore",
    },
    {
      id: 201,
      label: "Sint Maarten (Dutch part)",
      value: "Sint Maarten (Dutch part)",
    },
    {
      id: 202,
      label: "Slovakia",
      value: "Slovakia",
    },
    {
      id: 203,
      label: "Slovenia",
      value: "Slovenia",
    },
    {
      id: 204,
      label: "Solomon Islands",
      value: "Solomon Islands",
    },
    {
      id: 205,
      label: "Somalia",
      value: "Somalia",
    },
    {
      id: 206,
      label: "South Africa",
      value: "South Africa",
    },
    {
      id: 207,
      label: "South Georgia and the South Sandwich Islands",
      value: "South Georgia and the South Sandwich Islands",
    },
    {
      id: 208,
      label: "South Sudan",
      value: "South Sudan",
    },
    {
      id: 209,
      label: "Spain",
      value: "Spain",
    },
    {
      id: 210,
      label: "Sri Lanka",
      value: "Sri Lanka",
    },
    {
      id: 211,
      label: "Sudan",
      value: "Sudan",
    },
    {
      id: 212,
      label: "Suriname",
      value: "Suriname",
    },
    {
      id: 213,
      label: "Svalbard and Jan Mayen",
      value: "Svalbard and Jan Mayen",
    },
    {
      id: 214,
      label: "Swaziland",
      value: "Swaziland",
    },
    {
      id: 215,
      label: "Sweden",
      value: "Sweden",
    },
    {
      id: 216,
      label: "Switzerland",
      value: "Switzerland",
    },
    {
      id: 217,
      label: "Syrian Arab Republic",
      value: "Syrian Arab Republic",
    },
    {
      id: 218,
      label: "Taiwan",
      value: "Taiwan",
    },
    {
      id: 219,
      label: "Tajikistan",
      value: "Tajikistan",
    },
    {
      id: 220,
      label: "Tanzania",
      value: "Tanzania",
    },
    {
      id: 221,
      label: "Thailand",
      value: "Thailand",
    },
    {
      id: 222,
      label: "Timor-Leste",
      value: "Timor-Leste",
    },
    {
      id: 223,
      label: "Togo",
      value: "Togo",
    },
    {
      id: 224,
      label: "Tokelau",
      value: "Tokelau",
    },
    {
      id: 225,
      label: "Tonga",
      value: "Tonga",
    },
    {
      id: 226,
      label: "Trinidad and Tobago",
      value: "Trinidad and Tobago",
    },
    {
      id: 227,
      label: "Tunisia",
      value: "Tunisia",
    },
    {
      id: 228,
      label: "Turkey",
      value: "Turkey",
    },
    {
      id: 229,
      label: "Turkmenistan",
      value: "Turkmenistan",
    },
    {
      id: 230,
      label: "Turks and Caicos Islands",
      value: "Turks and Caicos Islands",
    },
    {
      id: 231,
      label: "Tuvalu",
      value: "Tuvalu",
    },
    {
      id: 232,
      label: "Uganda",
      value: "Uganda",
    },
    {
      id: 233,
      label: "Ukraine",
      value: "Ukraine",
    },
    {
      id: 234,
      label: "United Arab Emirates",
      value: "United Arab Emirates",
    },
    {
      id: 235,
      label: "United Kingdom of Great Britain and Northern Ireland",
      value: "United Kingdom of Great Britain and Northern Ireland",
    },
    {
      id: 236,
      label: "United States Minor Outlying Islands",
      value: "United States Minor Outlying Islands",
    },
    {
      id: 237,
      label: "United States of America",
      value: "United States of America",
    },
    {
      id: 238,
      label: "Uruguay",
      value: "Uruguay",
    },
    {
      id: 239,
      label: "Uzbekistan",
      value: "Uzbekistan",
    },
    {
      id: 240,
      label: "Vanuatu",
      value: "Vanuatu",
    },
    {
      id: 241,
      label: "Venezuela (Bolivarian Republic of)",
      value: "Venezuela (Bolivarian Republic of)",
    },
    {
      id: 242,
      label: "Vietnam",
      value: "Vietnam",
    },
    {
      id: 243,
      label: "Virgin Islands (British)",
      value: "Virgin Islands (British)",
    },
    {
      id: 244,
      label: "Virgin Islands (U.S.)",
      value: "Virgin Islands (U.S.)",
    },
    {
      id: 245,
      label: "Wallis and Futuna",
      value: "Wallis and Futuna",
    },
    {
      id: 246,
      label: "Western Sahara",
      value: "Western Sahara",
    },
    {
      id: 247,
      label: "Yemen",
      value: "Yemen",
    },
    {
      id: 248,
      label: "Zambia",
      value: "Zambia",
    },
    {
      id: 249,
      label: "Zimbabwe",
      value: "Zimbabwe",
    },
  ];

  const gender = [
    {
      id: 1,
      label: "Male",
      value: "Male",
    },
    {
      id: 2,
      label: "Female",
      value: "Female",
    },
    {
      id: 3,
      label: "Others",
      value: "Others",
    },
  ];

  const MaritalStatus = [
    {
      id: 1,
      label: "Single",
      value: "Single",
    },
    {
      id: 2,
      label: "Married",
      value: "Married",
    },
    {
      id: 3,
      label: "Widowed",
      value: "Widowed",
    },
    {
      id: 4,
      label: "Divorced",
      value: "Divorced",
    },
    {
      id: 5,
      label: "Separated",
      value: "Separated",
    },
  ];

  useEffect(() => {
    document.title = "Recruitment - Trackers";
    refetch(filter);
    // eslint-disable-next-line
  }, []);

  const refetch = (values) => {
    getData(values, page);
  };

  const navigation = [
    { id: 0, name: t("dashboard"), url: "/recruitment/dashboard" },
    {
      id: 1,
      name: t("candidate_tracker"),
      active: true,
    },
  ];

  const onChange = (page) => {
    setPage(page);
    getData(filter, page);
  };

  // const renderStatus = (record) => {
  //   if (record.status === 0)
  //     return <div className="bold text-red">Arranged</div>;
  //   if (record.status === 1)
  //     return <div className="bold text-blue">In Progress</div>;
  //   if (record.status === 2)
  //     return <div className="bold text-green">Completed</div>;
  // };

  const getData = async (values, page) => {
    setLoading(true);
    setData([]);
    let config = {
      headers: {
        Authorization: token,
      },
    };
    try {
      const queryParams = [];

      if (values.search) {
        queryParams.push(`search=${values.search}`);
      }

      if (values.createdBy) {
        queryParams.push(`createdBy=${values.createdBy}`);
      }

      if (values.Name) {
        queryParams.push(`Name=${values.Name}`);
      }

      if (values.Nationality) {
        queryParams.push(`Nationality=${values.Nationality}`);
      }

      if (values.dob) {
        queryParams.push(`dob=${values.dob}`);
      }

      if (values.PositionAppliedFor) {
        queryParams.push(`PositionAppliedFor=${values.PositionAppliedFor}`);
      }

      if (values.Gender) {
        queryParams.push(`Gender=${values.Gender}`);
      }

      if (values.MaritalStatus) {
        queryParams.push(`MaritalStatus=${values.MaritalStatus}`);
      }

      if (values.Status) {
        queryParams.push(`Status=${values.Status}`);
      }
      const queryString = queryParams.join("&");
      const Data = await axios.get(
        `/api/tracker?page=${page}${queryString ? "&" + queryString : ""}`,
        config
      );
      if (Data.status === 200) {
        setLoading(false);
        setData(Data.data.data);
        setTotal(Data.data.TotalDisplay);
      } else {
        if (Data.status === 201) {
          message.error(Data.data.error);
          setLoading(false);
        } else {
          message.error("Ouch, Something Went Terribly Wrong!");
          setLoading(false);
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  /** Formatted phone number */
  function formatPhoneNumber(phoneNumber) {
    const cleaned = phoneNumber.replace(/\D/g, '');
    let formatted = cleaned.startsWith('0') ? cleaned.slice(1) : cleaned;
    if (!formatted.startsWith('+')) {
      formatted = `+${formatted}`;
    }
    return formatted;
  }

  /** Confirm WhatsApp Chat */
  const confirmWhatsApp = (url) => {
    const whatsappURL = "https://wa.me/" + url;
    window.open(whatsappURL, '_blank');
  };
  const columns = [
    {
      title: t("contact_date"),
      render: (record) => (
        <div className="text-black bold">
          {dayjs(record.contactDate).format("ll")}
        </div>
      ),
    },
    {
      title: t("name"),
      render: (record) => <div className="text-black bold">{record.Name}</div>,
    },
    {
      title: t("nationality"),
      render: (record) => (
        <div className="text-black bold">{record.Nationality}</div>
      ),
    },
    // {
    //   title: "Date of Birth",
    //   render: (record) => (
    //     <div className="text-black bold">{dayjs(record.dob).format("ll")}</div>
    //   ),
    // },
    // {
    //   title: "Gender",
    //   render: (record) => (
    //     <div className="text-black bold">{record.Gender}</div>
    //   ),
    // },
    // {
    //   title: "MaritalStatus",
    //   render: (record) => (
    //     <div className="text-black bold">{record.MaritalStatus}</div>
    //   ),
    // },
    {
      title: t("resignation_notice_period"),
      render: (record) => (
        <div className="text-black bold">{record.ResignationNoticePeriod}</div>
      ),
    },
    // {
    //   title: "Expected Date Of Joining",
    //   render: (record) => (
    //     <div className="text-black bold">
    //       {dayjs(record.ExpectedDateOfJoining).format("ll")}
    //     </div>
    //   ),
    // },
    {
      title: t("position_applied_for"),
      render: (record) => (
        <div className="text-black bold">{record.PositionAppliedFor}</div>
      ),
    },
    // {
    //   title: "Client Company Name Being Interviewed For",
    //   render: (record) => (
    //     <div className="text-black bold">
    //       {record.ClientCompanyNameBeingInterviewedFor}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Years Of Toal Expereince",
    //   render: (record) => (
    //     <div className="text-black bold">{record.YearsOfToalExpereince}</div>
    //   ),
    // },
    // {
    //   title: "Years Of Related Experince",
    //   render: (record) => (
    //     <div className="text-black bold">{record.YearsOfRelatedExperince}</div>
    //   ),
    // },
    // {
    //   title: "Current Gross Salary",
    //   render: (record) => (
    //     <div className="text-black bold">{record.CurrentGrossSalary}</div>
    //   ),
    // },
    // {
    //   title: "Expected Gross Salary",
    //   render: (record) => (
    //     <div className="text-black bold">{record.ExpectedGrossSalary}</div>
    //   ),
    // },
    // {
    //   title: "Countries Worked Other Than Home Country",
    //   render: (record) => (
    //     <div className="text-black bold">
    //       {record.CountriesWorkedOtherThanHomeCountry}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Hightest Education Qualification",
    //   render: (record) => (
    //     <div className="text-black bold">
    //       {record.HightestEducationQualification}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Medical Certifications",
    //   render: (record) => (
    //     <div className="text-black bold">{record.MedicalCertifications}</div>
    //   ),
    // },
    // {
    //   title: "CV Source",
    //   render: (record) => (
    //     <div className="text-black bold">{record.CVSource}</div>
    //   ),
    // },
    // {
    //   title: "Contact Number",
    //   render: (record) => (
    //     <div className="text-black bold">{record.ContactNumber}</div>
    //   ),
    // },
    // {
    //   title: "WhatsApp",
    //   render: (record) => (
    //     <div className="text-black bold">{record.WhatsApp}</div>
    //   ),
    // },
    {
      title: t("email"),
      render: (record) => <div className="text-black bold">{record.Email}</div>,
    },
    {
      title: t("current_location"),
      render: (record) => (
        <div className="text-black bold">{record.CurrentLocation}</div>
      ),
    },
    // {
    //   title: "Type Of Visa",
    //   render: (record) => (
    //     <div className="text-black bold">{record.TypeOfVisa}</div>
    //   ),
    // },
    // {
    //   title: "Expiry Date Of Visa",
    //   render: (record) => (
    //     <div className="text-black bold">
    //       {dayjs(record.ExpiryDateOfVisa).format("ll")}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Comments",
    //   render: (record) => (
    //     <div className="text-black bold">{record.Comments}</div>
    //   ),
    // },
    {
      title: t("cv_upload"),
      render: (record) => (
        <div className="text-black bold">{record.CVUploaded}</div>
      ),
    },
    {
      title: t("created_by"),
      render: (record) => (
        <div className="text-black bold">{record.recruitmentName}</div>
      ),
    },
    {
      title: t("status"),
      render: (record) => (
        <div className="text-black bold">{record.Status}</div>
      ),
    },
    {
      title: t("WhatsApp Chat"),
      render: (record) => (
        <Space>
          <Popconfirm className="pop-confirm"
            title="Start WhatsApp Conversation"
            description={(
              <div>
                Are you sure you want to contact <strong>{record.Name}</strong> on WhatsApp?
              </div>
            )}
            onConfirm={() => confirmWhatsApp(formatPhoneNumber(record.WhatsApp))}
            okText="Yes"
            cancelText="No"
          >
            <WhatsAppOutlined style={{ fontSize: '35px', color: '#25D366' }} />
          </Popconfirm>
        </Space>
      ),
    },
    {
      title: t("actions"),
      render: (record) => (
        <div className="flex-small-gap">
          <Button type="primary" onClick={() => {
            toggleCommentModal(true);
            setEditData(record);
          }}
            ghost
          >
            <div className="bold">View Details</div>
          </Button>
          <Button type="primary" shape="round" icon={<EditOutlined />}
            onClick={() => {
              setEditData(record);
              toggleModal(true);
            }}
          />
          <Button type="primary" shape="round" danger icon={<DeleteOutlined />}
            onClick={() => {
              setDeletionData(record);
              toggleDeleteModal(true);
            }}
          />
          {record.isEmailSent ? (
            <Button shape="round" icon={<CheckCircleOutlined />}>
              Email Sent
            </Button>
          ) : (
              <Button type="primary" shape="round" danger icon={<MailOutlined />}
                loading={isLoadingMail === record.id}
              // onClick={() => {
              //   sendTrackerMail(record.Email, record.id);
              // }}
              onClick={() => {
                openEmailModel(record.Email, record.id);
              }}
            >
              Send Email
            </Button>
          )}
        </div>
      ),
      // width: "300px",
    },

  ];

  const openEmailModel = (email, id) => {
    setEmailModel(true);
    setEmailContent({ ...emailContent, email: email, id: id });
  };
  const sendTrackerMail = async () => {
    setLoadingMail(emailContent.id);
    var data = JSON.stringify({
      email: emailContent.email,
      trackerId: emailContent.id,
      subject: emailContent.subject,
      message: emailContent.message,
    });

    if (emailContent.subject.length < 3) {
      message.error("Please Provide Subject for this Email");
      return;
    }
    
    if (emailContent.message.length < 3) {
      message.error("Please Provide Message for this Email");
      return;
    }

    var config = {
      method: "post",
      url: `/api/tracker/trackeremail`,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(function (response) {
        message.success("Email Sent Successfully!");
        refetch(filter);
        setLoadingMail(false);
        setEmailModel(false);
      })
      .catch(function (error) {
        message.error(error?.response?.data?.error);
        setLoadingMail(false);
      });
  };

  const deleteData = async () => {
    setDeleteLoading(true);
    await axios({
      method: "delete",
      url: `/api/tracker/${deletionData.id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    })
      .then(function (response) {
        message.success("The data has been sucessfully deleted");
        toggleDeleteModal(false);
        setDeletionData("");
        refetch(filter);
        setDeleteLoading(false);
      })
      .catch(function (error) {
        message.error(error?.response?.data?.error);
        setDeleteLoading(false);
      });
  };

  const handleCancel = () => {
    toggleDeleteModal(false);
    setDeleteLoading(false);
    setDeletionData(null);
  };

  const handleUploadCancel = () => {
    toggleUploadModal(false);
    setJsonData([]);
  };

  const handleConvert = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        setJsonData(json);
      };
      reader.readAsBinaryString(file);
    }
  };

  const props = {
    accept: ".xls, .xlsx",
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      handleConvert(file);
      return false;
    },
  };

  const handleExcelUpload = async (values) => {
    setExcelLoading(true);
    const formattedTrackers = values.trackers.map((tracker) => ({
      ...tracker,
      contactDate: dayjs(tracker.contactDate).format("YYYY-MM-DD h:mm:ss"),
      dob: dayjs(tracker.dob).format("YYYY-MM-DD h:mm:ss"),
      ExpectedDateOfJoining: dayjs(tracker.ExpectedDateOfJoining).format(
        "YYYY-MM-DD h:mm:ss"
      ),
      ExpiryDateOfVisa: dayjs(tracker.ExpiryDateOfVisa).format(
        "YYYY-MM-DD h:mm:ss"
      ),
    }));

    try {
      const response = await axios.post(
        "/api/tracker/bulk",
        {
          trackers: formattedTrackers,
        },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      message.success("Data uploaded successfully." + response?.data?.message);
      setExcelLoading(false);
      handleUploadCancel();
      refetch(filter);
    } catch (error) {
      message.error("Failed to upload data.");
      setExcelLoading(false);
    }
  };

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      {isModalOpen && (
        <RecruitmentTrackerForm
          isModalOpen={isModalOpen}
          setModal={toggleModal}
          editData={editData}
          setEditData={setEditData}
          getData={refetch}
          clientsList={clientsList}
          clientFetching={clientFetching}
          jobsList={jobsList}
          jobFetching={jobFetching}
          filter={filter}
        />
      )}
      <Modal
        title="Delete Confirmation"
        open={deleteModal}
        onOk={deleteData}
        onCancel={handleCancel}
        okText={"Delete"}
        okType={"danger"}
        confirmLoading={deleteLoading}
      >
        <p>{`Are you sure you want to delete "${deletionData?.candidate}" from interview data?`}</p>
      </Modal>
      <Modal
        title={"More information"}
        open={isCommentModal}
        onCancel={() => {
          setEditData(null);
          toggleCommentModal(false);
        }}
        footer={false}
        centered
      >
        <div className="small-margin"></div>
        <Divider />
        <div className="small-margin flex-gap-column">
          <div>
            <div className="bolder text-black">contact Date</div>
            <div className="bold text-grey medium-text">
              {dayjs(editData?.contactDate).format("ll")}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Name</div>
            <div className="bold text-grey medium-text">{editData?.Name}</div>
          </div>
          <div>
            <div className="bolder text-black">Nationality</div>
            <div className="bold text-grey medium-text">
              {editData?.Nationality}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Date of Birth</div>
            <div className="bold text-grey medium-text">
              {dayjs(editData?.dob).format("ll")}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Gender</div>
            <div className="bold text-grey medium-text">{editData?.Gender}</div>
          </div>
          <div>
            <div className="bolder text-black">MaritalStatus</div>
            <div className="bold text-grey medium-text">
              {editData?.MaritalStatus}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Resignation Notice Period</div>
            <div className="bold text-grey medium-text">
              {editData?.ResignationNoticePeriod}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Expected Date Of Joining</div>
            <div className="bold text-grey medium-text">
              {dayjs(editData?.ExpectedDateOfJoining).format("ll")}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Position Applied For</div>
            <div className="bold text-grey medium-text">
              {editData?.PositionAppliedFor}
            </div>
          </div>
          <div>
            <div className="bolder text-black">
              Client Company Name Being Interviewed For
            </div>
            <div className="bold text-grey medium-text">
              {editData?.ClientCompanyNameBeingInterviewedFor}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Years Of Toal Expereince</div>
            <div className="bold text-grey medium-text">
              {editData?.YearsOfToalExpereince}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Years Of Related Experince</div>
            <div className="bold text-grey medium-text">
              {editData?.YearsOfRelatedExperince}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Current Gross Salary</div>
            <div className="bold text-grey medium-text">
              {editData?.CurrentGrossSalary}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Expected Gross Salary</div>
            <div className="bold text-grey medium-text">
              {editData?.ExpectedGrossSalary}
            </div>
          </div>
          <div>
            <div className="bolder text-black">
              Countries Worked Other Than Home Country
            </div>
            <div className="bold text-grey medium-text">
              {editData?.CountriesWorkedOtherThanHomeCountry}
            </div>
          </div>
          <div>
            <div className="bolder text-black">
              Hightest Education Qualification
            </div>
            <div className="bold text-grey medium-text">
              {editData?.HightestEducationQualification}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Medical Certifications</div>
            <div className="bold text-grey medium-text">
              {editData?.MedicalCertifications}
            </div>
          </div>
          <div>
            <div className="bolder text-black">CV Source</div>
            <div className="bold text-grey medium-text">
              {editData?.CVSource}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Contact Number</div>
            <div className="bold text-grey medium-text">
              {editData?.ContactNumber}
            </div>
          </div>
          <div>
            <div className="bolder text-black">WhatsApp</div>
            <div className="bold text-grey medium-text">
              {editData?.WhatsApp}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Email</div>
            <div className="bold text-grey medium-text">{editData?.Email}</div>
          </div>
          <div>
            <div className="bolder text-black">Current Location</div>
            <div className="bold text-grey medium-text">
              {editData?.CurrentLocation}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Type Of Visa</div>
            <div className="bold text-grey medium-text">
              {editData?.TypeOfVisa}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Expiry Date Of Visa</div>
            <div className="bold text-grey medium-text">
              {dayjs(editData?.ExpiryDateOfVisa).format("ll")}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Comments</div>
            <div className="bold text-grey medium-text">
              {editData?.Comments}
            </div>
          </div>
          <div>
            <div className="bolder text-black">CV Uploaded</div>
            <div className="bold text-grey medium-text">
              {editData?.CVUploaded}
            </div>
          </div>
          <div>
            <div className="bolder text-black">Status</div>
            <div className="bold text-grey medium-text">{editData?.Status}</div>
          </div>
        </div>
        <Divider orientation="left" orientationMargin="0">
          <div className="bolder text-black">Comments</div>
        </Divider>
        <div
          className="bold text-grey text-padding-left"
          style={{ textAlign: "justify" }}
        >
          {editData?.Comments && string(editData.Comments, "loaded")}
        </div>
      </Modal>
      <Modal
        destroyOnClose={true}
        title="Upload Excel"
        open={uploadModal}
        onOk={``}
        onCancel={handleUploadCancel}
        width={1000}
        okButtonProps={{ style: { display: "none" } }}
      >
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single upload. Only xls or xlsx files allowed to
            upload.
          </p>
        </Dragger>
        {jsonData.length > 0 && (
          <Form
            layout="vertical"
            className="flex-gap-column"
            onFinish={handleExcelUpload}
            initialValues={{
              trackers: jsonData.map((data) => ({
                contactDate:
                  data?.contactDate &&
                  dayjs(data?.contactDate).isValid() &&
                  dayjs(data?.contactDate),
                Name: data.Name,
                Nationality: data.Nationality,
                dob:
                  data?.dob && dayjs(data?.dob).isValid() && dayjs(data?.dob),
                Gender: data.Gender,
                MaritalStatus: data.MaritalStatus,
                ResignationNoticePeriod: data.ResignationNoticePeriod,
                ExpectedDateOfJoining:
                  data?.ExpectedDateOfJoining &&
                  dayjs(data?.ExpectedDateOfJoining),
                PositionAppliedFor: data.PositionAppliedFor,
                ClientCompanyNameBeingInterviewedFor:
                  data.ClientCompanyNameBeingInterviewedFor,
                YearsOfToalExpereince: data.YearsOfToalExpereince,
                YearsOfRelatedExperince: data.YearsOfRelatedExperince,
                CurrentGrossSalary: data.CurrentGrossSalary,
                ExpectedGrossSalary: data.ExpectedGrossSalary,
                CountriesWorkedOtherThanHomeCountry:
                  data.CountriesWorkedOtherThanHomeCountry,
                HightestEducationQualification:
                  data.HightestEducationQualification,
                MedicalCertifications: data.MedicalCertifications,
                CVSource: data.CVSource,
                ContactNumber: data.ContactNumber,
                WhatsApp: data.WhatsApp,
                Email: data.Email,
                CurrentLocation: data.CurrentLocation,
                TypeOfVisa: data.TypeOfVisa,
                ExpiryDateOfVisa:
                  data?.ExpiryDateOfVisa &&
                  dayjs(data?.ExpiryDateOfVisa).isValid() &&
                  dayjs(data?.ExpiryDateOfVisa),
                Comments: data.Comments,
                CVUploaded: data.CVUploaded,
                Status: data.Status,
              })),
            }}
          >
            {jsonData.map((data, i) => (
              <div key={i}>
                <Form.Item
                  name={["trackers", i, "Name"]}
                  label={"Candidate Name"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Name of Candidate",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Candidate Name"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "contactDate"]}
                  label={"Date of Contacting"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Contact Date",
                    },
                  ]}
                >
                  <DatePicker format="YYYY-MM-DD" />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "Gender"]}
                  label={"Gender"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Gender",
                    },
                  ]}
                >
                  <Select
                    placeholder={"Please Select Gender"}
                    options={gender}
                  />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "dob"]}
                  label={"Date of Birth"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Date Of Birth",
                    },
                  ]}
                >
                  <DatePicker format="YYYY-MM-DD" />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "MaritalStatus"]}
                  label={"Marital Status"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Marital Status",
                    },
                  ]}
                >
                  <Select
                    placeholder={"Please Select Marital Status"}
                    options={MaritalStatus}
                  />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "ResignationNoticePeriod"]}
                  label={"Resignation Notice Period"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Resignation Notice Period",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Resignation Notice Period"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "ExpectedDateOfJoining"]}
                  label={"Expected Date Of Joining"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Expected Date Of Joining",
                    },
                  ]}
                >
                  <DatePicker format="YYYY-MM-DD" />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "PositionAppliedFor"]}
                  label={"Position Applied For"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Position Applied For",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Position Applied For"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "ClientCompanyNameBeingInterviewedFor"]}
                  label={"Client Company Name Being Interviewed For"}
                  rules={[
                    {
                      required: true,
                      message:
                        "Please provide Client Company Name Being Interviewed For",
                    },
                  ]}
                >
                  <Input
                    placeholder={
                      "Enter Client Company Name Being Interviewed For"
                    }
                  />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "YearsOfToalExpereince"]}
                  label={"Years Of Toal Expereince"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Years Of Toal Expereince",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Years Of Toal Expereince"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "YearsOfRelatedExperince"]}
                  label={"Years Of Related Experince"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Years Of Related Experince",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Years Of Related Experince"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "CurrentGrossSalary"]}
                  label={"Current Gross Salary"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Current Gross Salary",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Current Gross Salary"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "ExpectedGrossSalary"]}
                  label={"Expected Gross Salary"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Expected Gross Salary",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Expected Gross Salary"} />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "CountriesWorkedOtherThanHomeCountry"]}
                  label={"Countries Worked Other Than Home Country"}
                  rules={[
                    {
                      required: true,
                      message:
                        "Please provide Countries Worked Other Than Home Country",
                    },
                  ]}
                >
                  <Input
                    placeholder={
                      "Enter Countries Worked Other Than Home Country"
                    }
                  />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "HightestEducationQualification"]}
                  label={"Hightest Education Qualification"}
                  rules={[
                    {
                      required: true,
                      message:
                        "Please provide Hightest Education Qualification",
                    },
                  ]}
                >
                  <Input
                    placeholder={"Enter Hightest Education Qualification"}
                  />
                </Form.Item>
                <Form.Item
                  name={["trackers", i, "MedicalCertifications"]}
                  label={"Medical Certifications"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Medical Certifications",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Medical Certifications"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "CVSource"]}
                  label={"CV Source"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide CV Source",
                    },
                  ]}
                >
                  <Input placeholder={"Enter CV Source"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "ContactNumber"]}
                  label={"Contact Number"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Contact Number",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Contact Number"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "WhatsApp"]}
                  label={"WhatsApp"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide WhatsApp",
                    },
                  ]}
                >
                  <Input placeholder={"Enter WhatsApp"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "Email"]}
                  label={"Email"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Email",
                    },
                  ]}
                >
                  <Input type="email" placeholder={"Enter Email"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "CurrentLocation"]}
                  label={"Current Location"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Current Location",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Current Location"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "TypeOfVisa"]}
                  label={"Type Of Visa"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Type Of Visa",
                    },
                  ]}
                >
                  <Input placeholder={"Enter Type Of Visa"} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "ExpiryDateOfVisa"]}
                  label={"Expiry Date Of Visa"}
                  rules={[
                    {
                      required: true,
                      message: "Please Expiry Date Of Visa",
                    },
                  ]}
                >
                  <DatePicker format="YYYY-MM-DD" />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "CVUploaded"]}
                  label={"CV Uploaded"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide CV Uploaded",
                    },
                  ]}
                >
                  <Select placeholder={"Cv Upload"} options={cvuploaded} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "Nationality"]}
                  label={"Nationality"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Nationality",
                    },
                  ]}
                >
                  <Select placeholder={"Nationality"} options={nation} />
                </Form.Item>

                <Form.Item
                  name={["trackers", i, "Status"]}
                  label={"Status"}
                  rules={[
                    {
                      required: true,
                      message: "Please provide Status",
                    },
                  ]}
                >
                  <Select placeholder={"Please Status"} options={status} />
                </Form.Item>

                <Form.Item
                  className="grid-2-column"
                  name={["trackers", i, "Comments"]}
                  label={"Comments"}
                >
                  <TextArea
                    placeholder="Enter the comments"
                    autoSize={{ minRows: 3 }}
                  />
                </Form.Item>
                <Divider />
              </div>
            ))}
            <Button
              className=""
              type="primary"
              htmlType="submit"
              loading={isExcelLoading}
            >
              Upload Data
            </Button>
          </Form>
        )}
      </Modal>
      <Modal
        destroyOnClose={true}
        afterClose={() =>
          setEmailContent({
            id: 0,
            email: "",
            subject: "",
            message: "",
          })
        }
        title="Send Email"
        open={isEmailModalOpen}
        onOk={``}
        onCancel={() => setEmailModel(false)}
        width={1000}
        okButtonProps={{ style: { display: "none" } }}
      >
        <Form
          layout="vertical"
          className="flex-gap-column"
          onFinish={sendTrackerMail}
        >
          <strong> {emailContent?.email} </strong>
          <Form.Item
            name="subject"
            label={"Subject"}
            rules={[
              {
                required: true,
                message: "Please provide Subject",
              },
            ]}
          >
            <Input
              onChange={(e) =>
                setEmailContent({ ...emailContent, subject: e.target.value })
              }
              showCount
              maxLength={200}
              placeholder={"Please Provide Subject"}
            />
          </Form.Item>
          <Form.Item
            name="message"
            label={"Message"}
            rules={[
              {
                required: true,
                message: "Please provide Message",
              },
            ]}
          >
            <TextArea
              onChange={(e) =>
                setEmailContent({ ...emailContent, message: e.target.value })
              }
              showCount
              maxLength={1000}
              placeholder="Type Message Here"
              style={{ height: 128 }}
            />
          </Form.Item>
          <Button
            className=""
            type="primary"
            htmlType="submit"
            loading={isLoadingMail}
          >
            Send Email
          </Button>
        </Form>
      </Modal>
      <Header
        home={"/recruitment/dashboard"}
        logOut={"/recruitment"}
        language={language}
        changeLanguage={changeLanguage}
      />
      <m.div
        className="recruitment-contacts"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <m.div className="title-text primary-color" variants={item}>
          {t("trackers")}
        </m.div>
        <m.div
          className="recruitment-filter-nav-header-without"
          variants={item}
        >
          <BreadCrumb items={navigation} />
          <div className="flex-small-gap">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setFilter({
                  ...filter,
                  search: name,
                });
                refetch({
                  search: name,
                  candidate: filter?.candidate || "",
                  client: filter?.client || "",
                  job: filter?.job || "",
                  interview: filter?.interview || "",
                });
              }}
            >
              <Input
                placeholder={t("search")}
                prefix={<AiOutlineSearch className="large-text" />}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Button className="hidden" htmlType="submit">
                {t("search")}
              </Button>
            </form>
            <Button
              type="primary"
              onClick={() => {
                toggleFilterModal(true);
              }}
              className={checkFilterActive(filter) && "filter-button--active"}
            >
              <FaFilter className="small-text" />
            </Button>
            <Button
              type="primary"
              onClick={() => {
                toggleUploadModal(true);
              }}
            >
              + {t("Upload Excel")}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setEditData(null);
                toggleModal(true);
              }}
            >
              + {t("create")}
            </Button>
          </div>
        </m.div>
        <AnimatePresence>
          {isFilterModal && (
            <RecruitmentTrackerFilter
              isFilterModal={isFilterModal}
              toggleFilterModal={toggleFilterModal}
              filterData={filter}
              setFilterData={setFilter}
              getData={refetch}
              loading={isLoading}
              clientResult={clientsList}
              createdBy={createdBy}
              createdByFetching={createdByFetching}
              jobResult={jobsList}
            />
          )}
        </AnimatePresence>
        <m.div variants={item}>
          <Table
            dataSource={data}
            columns={columns}
            loading={isLoading}
            pagination={false}
            rowKey={"id"}
          />
          <div className="pagination">
            <div className="pagination-total">{`Showing ${
              page === 1 ? 1 : page * 10 - 10 + 1
            } to ${page * 10 > total ? total : page * 10} of ${total}`}</div>
            <Pagination
              current={page}
              onChange={onChange}
              total={total}
              showSizeChanger={false}
            />
          </div>
        </m.div>
      </m.div>
    </m.div>
  );
};

export default RecruitmentTrackers;
